<div mat-dialog-content class="alert-dialog-content">
    <p>{{ message }}</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onClose()">Close</button>
</div>
